import img1 from "../../assets/images/Home/dummy_slider_img.png";

const images = [
  { image: img1 },
  { image: img1 },
  { image: img1 },
  { image: img1 },
  { image: img1 },
  { image: img1 },
  { image: img1 },
  { image: img1 },
  { image: img1 },
  { image: img1 },
  { image: img1 },
  { image: img1 },
  { image: img1 },
  { image: img1 },
  { image: img1 },
  { image: img1 },
  { image: img1 },
  { image: img1 },
  { image: img1 },
  { image: img1 },
  { image: img1 },
  { image: img1 },
  { image: img1 },
  { image: img1 },
];

export { images };
